import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Lock, Clock } from "lucide-react";

interface AdminLockoutStateProps {
  lockoutRemaining: number;
}

export const AdminLockoutState: React.FC<AdminLockoutStateProps> = ({ lockoutRemaining }) => {
  return (
    <main className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="max-w-md w-full border-destructive">
        <CardHeader className="space-y-1">
          <CardTitle className="flex items-center gap-2 text-destructive">
            <Lock className="h-5 w-5" />
            Account Temporarily Locked
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Too many failed verification attempts. For security purposes, 
            access to the admin dashboard has been temporarily disabled.
          </p>
          <div className="flex items-center gap-2 p-3 rounded-lg bg-destructive/10 text-destructive">
            <Clock className="h-4 w-4 shrink-0" />
            <span className="text-sm font-medium">
              Try again in {lockoutRemaining} minute{lockoutRemaining !== 1 ? 's' : ''}
            </span>
          </div>
          <p className="text-xs text-muted-foreground">
            If you believe this is an error, please contact your system administrator.
          </p>
        </CardContent>
      </Card>
    </main>
  );
};
